export default __webpack_public_path__ + "a1f22eb.png";